import script from "./PackageComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PackageComponent.vue?vue&type=script&setup=true&lang=js"

import "./PackageComponent.vue?vue&type=style&index=0&id=58c189e4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58c189e4"]])

export default __exports__